import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  BulkAllocationDetailRequest,
  BulkAllocationDetailResponse,
  BulkAllocationDetailState,
  BulkAllocationListRequest,
  BulkAllocationListResponse,
  BulkAllocationListState,
} from 'redux/types/Allocation.types';

export const bulkAllocationListInitialState: BulkAllocationListState = {
  loading: false,
  error: null,
  data: [],
  pagination: null,
};

export const bulkAllocationDetailInitialState: BulkAllocationDetailState = {
  loading: false,
  error: null,
  data: [],
  pagination: null,
};

interface FetchBulkAllocationListPayload {
  page: number;
  pageSize: number;
  filters?: BulkAllocationListRequest;
}

const BulkAllocationListSlice = createSlice({
  name: 'bulkAllocationList',
  initialState: bulkAllocationListInitialState,
  reducers: {
    fetchBulkAllocationListReq: (
      state,
      _action: PayloadAction<FetchBulkAllocationListPayload>
    ) => {
      state.loading = true;
      state.error = null;
    },
    fetchBulkAllocationListSuccess: (
      state,
      action: PayloadAction<BulkAllocationListResponse>
    ) => {
      state.loading = false;
      state.data = action.payload.data.items;
      state.pagination = {
        page: action.payload.data.pagination.page,
        pageSize: action.payload.data.pagination.pageSize,
        totalRecords: action.payload.data.pagination.total,
        totalPages: action.payload.data.pagination.totalPages,
      };
    },
    fetchBulkAllocationListFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetBulkAllocationListState: (state) => {
      state.loading = false;
      state.error = null;
      state.data = [];
      state.pagination = null;
    },
  },
});

const BulkAllocationDetailSlice = createSlice({
  name: 'bulkAllocationDetail',
  initialState: bulkAllocationDetailInitialState,
  reducers: {
    fetchBulkAllocationDetailReq: (
      state,
      _action: PayloadAction<BulkAllocationDetailRequest>
    ) => {
      state.loading = true;
      state.error = null;
    },
    fetchBulkAllocationDetailSuccess: (
      state,
      action: PayloadAction<BulkAllocationDetailResponse>
    ) => {
      state.loading = false;
      state.data = action.payload.data;
      state.pagination = {
        page: action.payload.page,
        pageSize: action.payload.page_size,
        totalRecords: action.payload.total_records,
        totalPages: action.payload.total_pages,
      };
    },
    fetchBulkAllocationDetailFailure: (
      state,
      action: PayloadAction<string>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetBulkAllocationDetailState: (state) => {
      state.loading = false;
      state.error = null;
      state.data = [];
      state.pagination = null;
    },
  },
});

export const {
  fetchBulkAllocationListReq,
  fetchBulkAllocationListSuccess,
  fetchBulkAllocationListFailure,
  resetBulkAllocationListState,
} = BulkAllocationListSlice.actions;

export const {
  fetchBulkAllocationDetailReq,
  fetchBulkAllocationDetailSuccess,
  fetchBulkAllocationDetailFailure,
  resetBulkAllocationDetailState,
} = BulkAllocationDetailSlice.actions;

export const bulkAllocationListReducer = BulkAllocationListSlice.reducer;
export const bulkAllocationDetailReducer = BulkAllocationDetailSlice.reducer;
